import { User } from '@/core/models/user.model';
import { WidgetTeacherSectionItem } from './widget-teacher-section-item.model';

export class WidgetTeacherSectionList {
  id: number;
  name: string;
  classId: number;
  courseId: number;
  users: {
    content: WidgetTeacherSectionItem[],
    more: boolean,
    page: number,
  };
  resolved: boolean;
  constructor(data: any) {
    this.id = data.id;
    this.name = data.name;
    this.classId = data.classId;
    this.courseId = data.courseId;
    this.users = {
      content: [],
      more: true,
      page: 0
    };
    this.resolved = data.resolved;
  } 
}